let pos;

var openOldCart = function () {
    $.fancybox.open({
        href: '/cart/oldItems/?action=getListHtml',
        type: 'ajax',
        width: '650px',
        maxWidth: '650px',
        maxHeight: '85%',
        beforeShow: function () {
            pos = $('html').scrollTop();
            $('html').scrollTop(0);
            $('body').addClass('no-srcoll');
        },
        onUpdate: function () {
            $('#old-cart').css('opacity', '1');
        },
        afterShow: function () {
            setTimeout(function () {
                $.fancybox.update();
            }, 100);
        },
        afterClose: function () {
            $('body').removeClass('no-srcoll');
            $('html').scrollTop(pos);
        },
    });
};

var openOldCartReplace = function () {
    $.fancybox.open({
        href: '/cart/oldItems/?action=getListHtml',
        type: 'ajax',
        width: '650px',
        maxWidth: '650px',
        maxHeight: '85%',
        beforeShow: function () {
            pos = $('html').scrollTop();
            $('html').scrollTop(0);
            $('body').addClass('no-srcoll');
        },
        onUpdate: function () {
            $('#old-cart').css('opacity', '1');
        },
        afterShow: function () {
            setTimeout(function () {
                $.fancybox.update();
            }, 100);
        },
        afterClose: function () {
            $('body').removeClass('no-srcoll');
            var url = $('#phone_form').data('back-url');
            if ($('#phone_form').length !== 0) {
                location.replace(url);
            } else {
                location.reload();
            }
        },
    });
};

export { openOldCart };
export { openOldCartReplace };
